import { Component } from '@angular/core';
import { NavController, ToastController, LoadingController, NavParams, AlertController } from 'ionic-angular';

import { ProjectDetailPage } from '../project-detail/page';
import { FormTenderPage, LoginPage, ProfilePage, ActivityPage } from '../';

import { TenderMarketing, UserMarketing as User, MasterMarketing as Master } from '@providers/index';

@Component({
  selector: 'page-list-project',
  templateUrl: 'page.html'
})
export class ListProjectPage {

  user:any={};
  listProject:any = [];
  total_rows=0;
  listStage:any = [];
  listStatus:any=[];
  params:any = {};
  title= "List Tender";
  akses:any={};
  searchBar=false;

  currentPage = 1;
  pageSize    = 50;
  total_page  = 0;

  constructor(
    public navCtrl     : NavController,
    public toastCtrl   : ToastController,
    public loadingCtrl : LoadingController,
    public navParams   : NavParams,
    public alertCtrl   : AlertController,
    public tenderApi   : TenderMarketing,
    public masterApi   : Master,
    public userApi     : User
  ) {
    this.params.all_sbu = 1;
    
    if(this.userApi.akses.lihat_tender_group_data=="all"){
      this.params.all_branch = 1;
      this.params.all_company = 1;
      this.params.all_sbu = 1;
    }

    if(this.navParams.get('params')!=undefined){
      this.params = this.navParams.get('params');
    }
    this.akses = this.userApi.akses;
    this.user = this.userApi.data;

    // if(this.userApi.akses.lihat_tender_group_data=='branch'){
      
    //     this.params.branch_ids = this.userApi.data.hrm_company_office_id,
    //     this.params.company_ids = this.userApi.data.company_id
      
    // }else 
    if(this.userApi.akses.lihat_tender_group_data=='mine'){
      this.params = {
        created_by : this.userApi.data.employee_id
      }
    }
    // else if(this.userApi.akses.lihat_tender_group_data=='fitur_user_data'){
    //   this.params=this.userApi.akses.lihat_tender_user_data;
    // }
  }

  ionViewDidEnter() {
    this.getList();
    this.getStage();
    this.getStatus();
  }

  ionViewDidLoad(){
    this.getDisclaimer();
  }

  doRefresh(refresher) {
    refresher.complete();
    this.getList();
  }

  getStage(){
    let params = {};
    this.masterApi.stage(params).subscribe((resp:any) => {
      this.listStage = resp.data;
    });
  }

  getStatus(){
    let params = {};
    this.masterApi.status(params).subscribe((resp:any) => {
      this.listStatus = resp.data;
    });
  }
  
  presentToast(msg){
    this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top'
    }).present();
  }

  getList(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();
    let params:any = this.params;
    params.page     = this.currentPage,
    params.pageSize = this.pageSize
    this.tenderApi.get(params).subscribe((resp:any) => {
      this.listProject = resp.data;
      this.total_rows = resp.total_rows;
      this.total_page = this.total_rows/this.pageSize;
      this.total_page = Math.ceil(this.total_page);
      loading.dismiss();
    },(err) => {
      this.presentToast('Failed to Load Data.');
      loading.dismiss();
    });
  }

  toProjectDetail(item) {
    this.navCtrl.push(ProjectDetailPage, {
      tender_id: item.id
    });
  }

  add() {
    this.navCtrl.push(FormTenderPage, {});
  }

  stageChange(e,rec){
    this.getList();
  }
  statusChange(e,rec){
    this.getList();
  }

  onInput(e){
    this.currentPage = 1;
    this.pageSize    = 50;
    this.total_rows  = 0;
    this.total_page  = 0;
    this.getList();
  }

  onCancel(e){
    this.currentPage = 1;
    this.pageSize    = 50;
    this.total_rows  = 0;
    this.total_page  = 0;
    this.getList();
  }

  confirmLogout() {
    const confirm = this.alertCtrl.create({
      title: 'Yakin akan keluar ?',
      buttons: [
        {
          text: 'Tidak',
          handler: () => {

          }
        },
        {
          text: 'Ya',
          handler: () => {
            this.logout();
          }
        }
      ]
    });
    confirm.present();
  }

  logout(){
    localStorage.clear();
    this.navCtrl.push(LoginPage);
  }

  toProfile(){
    this.navCtrl.push(ProfilePage);
  }

  toActivity(){
    let pids = [];
    this.listProject.forEach(rec => {
      pids.push(rec.id);
    });
    this.navCtrl.push(ActivityPage,{
      tender_ids : pids
    });
  }

  getDisclaimer(){
    this.masterApi.getDisclaimer().subscribe((resp:any) => {
      if(resp.disclaimer =="" || resp.disclaimer ==null){

      }
      else{
        let pop = this.alertCtrl.create({
          title   : 'Notice',
          subTitle: resp.disclaimer,
          buttons : ['OK']
        });
        pop.present();
        console.log("Disclaimer => ", resp.disclaimer);
      }
    }); 
  }

  showSearch(){
    this.searchBar=true;
  }
  hideSearch(){
    this.searchBar=false;
  }

  first(){
    this.currentPage=1;
    this.getList()
  }
  last(){
    this.currentPage=this.total_page;
    this.getList()
  }
  next(){
    this.currentPage++;
    this.getList()
  }
  prev(){
    this.currentPage--;
    this.getList()
  }


}



// WEBPACK FOOTER //
// ./src/pages/marketing/list-project/page.ts